import { Space, Typography } from '@/components/core-v2'

import { reorderItemListsToMatchById } from '../../utils'
import { ProposedChangeAssetTable } from './proposed-changes-asset-table'
import { StyledVerticalDivider } from './styled-vertical-divider'
import { ApiAssetWeightWithDifference, ApiInvestmentAssetWeightWithDifference } from './types'

interface ProposedChangesModalAssetsSectionProps {
  currentInvestmentWeights: ApiInvestmentAssetWeightWithDifference[]
  currentWeights: ApiAssetWeightWithDifference[]
  proposedInvestmentWeights: ApiInvestmentAssetWeightWithDifference[]
  proposedWeights: ApiAssetWeightWithDifference[]
}

export const ProposedChangesModalAssetsSection = ({
  currentInvestmentWeights,
  currentWeights,
  proposedInvestmentWeights,
  proposedWeights
}: ProposedChangesModalAssetsSectionProps) => {
  const [currentTargetWeights, proposedTargetWeights] = reorderItemListsToMatchById({
    array1: currentWeights,
    array2: proposedWeights,
    mappingLogic: asset => [asset.asset.assetId, asset]
  })
  currentWeights = currentTargetWeights
  proposedWeights = proposedTargetWeights

  const setAssetDifferences = (
    listBeingChecked: ApiAssetWeightWithDifference[],
    listToCheckAgainst: ApiAssetWeightWithDifference[]
  ) => {
    const checkAgainstMap = new Map(listToCheckAgainst.map(asset => [asset.asset.assetId, asset]))

    listBeingChecked.forEach(asset => {
      const checkAgainstAsset = checkAgainstMap.get(asset.asset.assetId)

      if (!checkAgainstAsset) {
        // if unique then it is different
        asset.different = true
      } else {
        asset.different = false
      }

      // if value has changed then it is different
      if (checkAgainstAsset?.weight !== asset.weight) {
        asset.different = true
      } else {
        asset.different = false
      }
    })
  }

  setAssetDifferences(currentWeights, proposedWeights)
  setAssetDifferences(proposedWeights, currentWeights)

  return (
    <Space isflex flexGrow={1}>
      <Space
        alignItems="center"
        data-testid="current-assets"
        flexBasis="50%"
        flexDirection="column"
        mr={3}
      >
        <Space mb={6}>
          <Typography fontSize="15px" fontWeight="bold" textAlign="center" variant="b3">
            Current
          </Typography>
        </Space>
        <ProposedChangeAssetTable
          assetList={currentWeights}
          investmentAssetList={currentInvestmentWeights}
        />
      </Space>
      <StyledVerticalDivider />
      <Space
        alignItems="center"
        data-testid="proposed-assets"
        flexBasis="50%"
        flexDirection="column"
        ml={3}
      >
        <Space mb={6}>
          <Typography fontSize="15px" fontWeight="bold" textAlign="center" variant="b3">
            Proposed changes
          </Typography>
        </Space>
        <ProposedChangeAssetTable
          assetList={proposedWeights}
          investmentAssetList={proposedInvestmentWeights}
        />
      </Space>
    </Space>
  )
}
